import type { CorrectComponentType } from "/npm/@brytdesigns/web-component-utils@0.1.7";

import { createEffect, on } from "/npm/solid-js@^1.9.5/+esm";
import { provideHybridCartContext } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/useHybridCart.js";

type CartContextProps = {
  debug?: boolean;
};

export const CartContext: CorrectComponentType<CartContextProps> = (
  props,
  { element },
) => {
  const cart = provideHybridCartContext(element);
  createEffect(
    on(
      () => ({
        cart: cart(),
        debug: props.debug,
      }),
      ({ cart, debug }) => {
        if (!debug) return;
        console.log("Cart updated:", cart);
      },
    ),
  );
};
